import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/withdrawal";

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Approve = async (data) => {
    return await axiosInstance(options).post(`${path}/approve`, data);
}

export const Reject = async (data) => {
    return await axiosInstance(options).post(`${path}/reject`, data);
}